import React from 'react';
import PropTypes from 'prop-types';

import DOMPurify from 'dompurify';

import t from 'utils/translate';

const translate = (expression, substitute) => {
  return t('en', expression, substitute);
};

const Translate = ({expression, substitute}) => {
  const translatedString = translate(expression, substitute);

  const safeString = DOMPurify.sanitize(translatedString || '', {USE_PROFILES: {html: true}, ADD_ATTR: ['target']});

  return (
    <span
      dangerouslySetInnerHTML={{__html: safeString}}
    />
  );
};
Translate.propTypes = {
  expression: PropTypes.string,
  substitute: PropTypes.object,
};

const formatCurrency = (amount, currency = 'USD', locale = 'en-US') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(amount);
};
const Currency = (props) => (<div>{formatCurrency(props.amount)}</div>);

Currency.propTypes = {
  amount: PropTypes.number,
};

export {
  Translate,
  translate,
  formatCurrency,
  Currency,
};
